// 处理前端请求数据拥有共同url的封装

// 引入axios模块
import axios from "axios";

const request = axios.create({
  baseURL: "http://houtai.grunen.cn/api",
  timeout: 10000,
});

// 添加请求拦截器
request.interceptors.request.use(
  function (config) {
    // 在发送请求之前做：将token添加到headers对象
    // console.log('请求拦截器', config)
    // config.headers.common.token = localStorage.getItem('token')
    // config.headers.common.token = $cookies.get('token')

    // 添加loading...
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
request.interceptors.response.use(
  function (response) {
    // 对响应数据做：验证登录状态，没登录，跳转到登录
    // console.log('响应拦截器', response)
    // 后端验证失败,前端验证通过,后端守
    // 后端验证失败,前端也验证失败,前端守
    // if (response.data.state === 202 && $cookies.get('isLogin') === 'ok') {
    //     location.href = 'http://wangfangle.club/login'
    // }
    // 删除loading
    return response;
  },
  function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

export default request;
